module.exports = __webpack_public_path__ + "img/Methadone (MTD).39a4dc3e.png";